var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_957_306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79463 12.5C5.56713 13.2784 3.16663 16.2212 3.16663 19.7326C3.16663 23.8383 6.44852 27.1667 10.4969 27.1667C11.1914 27.1667 11.8633 27.0688 12.5 26.8857",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5386 12.5C28.7661 13.2784 31.1666 16.2212 31.1666 19.7326C31.1666 23.8383 27.8847 27.1667 23.8363 27.1667C23.1418 27.1667 22.4699 27.0688 21.8333 26.8857",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 12.5C25.8333 8.08173 21.9531 4.5 17.1667 4.5C12.3802 4.5 8.5 8.08173 8.5 12.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.5673L17.1012 24.5L21.8333 20.5",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.5673L17.1012 24.5L21.8333 20.5L12.5 20.5673Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 12.5V21.8333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_957_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.4a150e0b548a65a4d9e8cde7b8a378df.svg";
export { ForwardRef as ReactComponent };